import * as Tooltip from '~/components/ui/Tooltip';

type ClippedTextTooltipProps = {
  text: React.ReactNode;
  triggerClassName?: string;
  contentClassName?: string;
};

export function ClippedTextTooltip({ text, triggerClassName, contentClassName }: ClippedTextTooltipProps) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className={`truncate ${triggerClassName ?? ''}`}>{text}</div>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content side="bottom" align="center" sideOffset={6}>
            <span className={`truncate ${contentClassName ?? ''}`}>{text}</span>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
